import type { LucideProps } from "lucide-react"

export function PiIcon(props: LucideProps) {
  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 10 10"
      preserveAspectRatio="xMidYMid"
      {...props}
    >
      <g className="fill-black dark:fill-white">
        <rect x="0" y="0" width="1" height="1" />
        <rect x="1" y="0" width="1" height="1" />
        <rect x="2" y="0" width="1" height="1" />
        <rect x="3" y="0" width="1" height="1" />
        <rect x="4" y="0" width="1" height="1" />
        <rect x="5" y="0" width="1" height="1" />
        <rect x="6" y="0" width="1" height="1" />
        <rect x="0" y="1" width="1" height="1" />
        <rect x="1" y="1" width="1" height="1" />
        <rect x="2" y="1" width="1" height="1" />
        <rect x="3" y="1" width="1" height="1" />
        <rect x="4" y="1" width="1" height="1" />
        <rect x="5" y="1" width="1" height="1" />
        <rect x="6" y="1" width="1" height="1" />
        <rect x="0" y="2" width="1" height="1" />
        <rect x="1" y="2" width="1" height="1" />
        <rect x="5" y="2" width="1" height="1" />
        <rect x="6" y="2" width="1" height="1" />
        <rect x="0" y="3" width="1" height="1" />
        <rect x="1" y="3" width="1" height="1" />
        <rect x="5" y="3" width="1" height="1" />
        <rect x="6" y="3" width="1" height="1" />
        <rect x="0" y="4" width="1" height="1" />
        <rect x="1" y="4" width="1" height="1" />
        <rect x="5" y="4" width="1" height="1" />
        <rect x="6" y="4" width="1" height="1" />
        <rect x="0" y="5" width="1" height="1" />
        <rect x="1" y="5" width="1" height="1" />
        <rect x="2" y="5" width="1" height="1" />
        <rect x="3" y="5" width="1" height="1" />
        <rect x="4" y="5" width="1" height="1" />
        <rect x="7" y="5" width="1" height="1" />
        <rect x="8" y="5" width="1" height="1" />
        <rect x="9" y="5" width="1" height="1" />
        <rect x="0" y="6" width="1" height="1" />
        <rect x="1" y="6" width="1" height="1" />
        <rect x="2" y="6" width="1" height="1" />
        <rect x="3" y="6" width="1" height="1" />
        <rect x="4" y="6" width="1" height="1" />
        <rect x="7" y="6" width="1" height="1" />
        <rect x="8" y="6" width="1" height="1" />
        <rect x="9" y="6" width="1" height="1" />
        <rect x="0" y="7" width="1" height="1" />
        <rect x="1" y="7" width="1" height="1" />
        <rect x="7" y="7" width="1" height="1" />
        <rect x="8" y="7" width="1" height="1" />
        <rect x="9" y="7" width="1" height="1" />
        <rect x="0" y="8" width="1" height="1" />
        <rect x="1" y="8" width="1" height="1" />
        <rect x="7" y="8" width="1" height="1" />
        <rect x="8" y="8" width="1" height="1" />
        <rect x="9" y="8" width="1" height="1" />
        <rect x="0" y="9" width="1" height="1" />
        <rect x="1" y="9" width="1" height="1" />
        <rect x="7" y="9" width="1" height="1" />
        <rect x="8" y="9" width="1" height="1" />
        <rect x="9" y="9" width="1" height="1" />
      </g>
    </svg>
  )
}
